import { useState } from 'react'

import { CommonFormContextProps } from '../types'

type Props = Partial<Pick<CommonFormContextProps, 'touched'>> &
  Pick<CommonFormContextProps, 'formId'>

export const useCommonFormContextProps = ({
  formId,
  touched: initialTouched,
}: Props): CommonFormContextProps => {
  const [loading, setLoading] = useState<boolean>(false)
  const [touched, setTouched] = useState<boolean>(initialTouched ?? false)
  const [valid, setValid] = useState<boolean>(true)

  return {
    formId,
    loading,
    setLoading,
    setTouched,
    setValid,
    touched,
    valid,
  }
}
